(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbInternalMsgBus"), require("sbAuthorizationLib"));
	else if(typeof define === 'function' && define.amd)
		define("sbDataLayer", ["sbInternalMsgBus", "sbAuthorizationLib"], factory);
	else if(typeof exports === 'object')
		exports["sbDataLayer"] = factory(require("sbInternalMsgBus"), require("sbAuthorizationLib"));
	else
		root["sbDataLayer"] = factory(root["sbInternalMsgBus"], root["sbAuthorizationLib"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__20__, __WEBPACK_EXTERNAL_MODULE__161__) {
return 